import { useQuery } from "@apollo/client"
import Builder, { IFormMeta } from "./forms/builder/Builder"
import { IGetFormContentInput, IGetFormContentOutput, IGetHealthCoachFormTemplatesInput, IGetHealthCoachFormTemplatesOutput, IHealthCoachFormTemplatesOutput } from "../graphql/types/queries/forms"
import { GET_FORM_CONTENT, GET_HEALTHCOACH_FORM_TEMPLATES } from "../graphql/queries"
import { useState } from "react"
import PleaseWait from "../components/PleaseWait"
import PickTemplate from "./forms/builder/PickTemplate"
import { Box, Button, Flex, Text } from "rebass/styled-components"
import { useLocation, useNavigate } from "react-router-dom"
import { IProperties } from "./forms/builder/types"
import { Form, Formik } from "formik"
import * as Yup from 'yup';
import { parseStringify } from "../utils/StringUtils"
import FormField from "../components/FormField"
import { TextInputWithLabel } from "../components/TextInput"
import Modal from "styled-react-modal"
import { SpecialModalBackground } from "../components/Commons"

const BuilderNew = () => {

  const location = useLocation();
  const [selectedTemplate, setSelectedTemplate] = useState<{
    template: IHealthCoachFormTemplatesOutput,
    meta: IFormMeta
  } | null>()
  const { data, loading, refetch, error } = useQuery<IGetHealthCoachFormTemplatesOutput, IGetHealthCoachFormTemplatesInput>(GET_HEALTHCOACH_FORM_TEMPLATES)

  const onSelectedHandler = (template: IHealthCoachFormTemplatesOutput, meta: IFormMeta) => {
    setSelectedTemplate({
      template,
      meta
    })
  }
  if (!!loading) return <PleaseWait />
  if (!data?.getHealthCoachFormTemplates) return <Text>An error occured</Text>
  return (
    <>
      {
        !selectedTemplate ? (
          <PickTemplate forceTargetId={(location.state || {} as any).useTargetId} forceTemplateId={(location.state || {} as any).useTemplateId} templates={data?.getHealthCoachFormTemplates} onSelected={onSelectedHandler} />
        ) : (
          <Builder meta={selectedTemplate.meta} templateTree={JSON.parse(selectedTemplate.template.content) || []} />
        )
      }
    </>
  )
}
const schema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(2, 'Question must be greater than 1 character')
    .required('Required'),
});
const BuilderFromExisting = ({ formId, isDuplicate }: { formId: string, isDuplicate?: boolean }) => {
  const location = useLocation();
  const navigate = useNavigate()
  const [selectedTemplate, setSelectedTemplate] = useState<{
    template: IProperties[],
    meta: IFormMeta
  } | null>()

  const [isSettingName, setIsSettingName] = useState(true)//(!!isDuplicate)

  const { data: dataFormContent, loading: loadingFormContent, error: errorFormContent } = useQuery<IGetFormContentOutput, IGetFormContentInput>(GET_FORM_CONTENT, {
    variables: {
      formId
    },
    onCompleted: (e) => {
      setSelectedTemplate({
        meta: {
          id: isDuplicate ? undefined : e.getFormContent.id,
          name: e.getFormContent.name,
          target: e.getFormContent.target.id,
          targetName: e.getFormContent.target.target,
          version: e.getFormContent.version,
          description: e.getFormContent.description,
          basedOnTemplate: e.getFormContent.basedOnTemplate?.id || '',
          templateBuilderUpdatedAt: e.getFormContent.basedOnTemplate?.builderUpdatedAt,
          formBuilderUpdatedAt: e.getFormContent.builderUpdatedAt
        },
        template: JSON.parse(e.getFormContent.content)
      })
    }
  })

  if (!!loadingFormContent) return <PleaseWait />
  if (!selectedTemplate || !selectedTemplate.meta) return <Text>An error occured</Text>
  if (isSettingName) {
    return (

      <Modal
        isOpen={true}
        onBackgroundClick={() => {
          navigate('/form-listing');
        }}
        onEscapeKeydown={() => {
          navigate('/form-listing');
        }}
      >
        <SpecialModalBackground
          onClick={() => {
            navigate('/form-listing');
          }}
        >
          <Box
            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
              padding: '24px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              maxWidth: '95vw',
              minWidth: 'initial',
              maxHeight: '95vh',
              overflowY: 'hidden',
            }}
            onClick={(e) => {
              // e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
              <Formik
                initialValues={{
                  name: selectedTemplate.meta.name,
                  description: selectedTemplate.meta.description
                }}
                isInitialValid={() => {
                  try {
                    const aa = schema.isValidSync({
                      name: selectedTemplate.meta.name,
                      description: selectedTemplate.meta.description
                    });

                    return aa
                  } catch (err) {
                    return false;
                  }
                }}
                validationSchema={schema}
                onSubmit={(values) => {
                  let curr = parseStringify(selectedTemplate.meta) as IFormMeta
                  curr.name = values.name
                  curr.description = values.description
                  setSelectedTemplate({
                    ...selectedTemplate,
                    meta: curr
                  })
                  setIsSettingName(false)
                }}
              >
                {({ touched, errors, isValid, values }) => {
                  return (
                    <>
                      <Form>
                        <FormField mb={3} error={touched.name && errors.name}>
                          <TextInputWithLabel placeholder={isDuplicate?"Form name (you can change it)":'Form name'} name="name" id="input_name" />
                        </FormField>

                        <FormField mb={4} error={touched.description && errors.description}>
                          <TextInputWithLabel placeholder="Form description" name="description" id="input_name" />
                        </FormField>
                        <Flex alignItems="center" flexDirection="column">
                          <Button disabled={!isValid} variant="primary" width={1 / 2} type="submit" id="btn_login">
                           {isDuplicate?'Create Duplicated Form':'Continue'} 
                          </Button>
                        </Flex>
                      </Form>

                    </>
                  );
                }}
              </Formik>
            </Flex>
          </Box>
        </SpecialModalBackground>
      </Modal>
    )
  }
  return (
    <>
      <Builder meta={selectedTemplate.meta} templateTree={selectedTemplate.template || []} />
    </>
  )
}
const FormBuilder = () => {
  const location = useLocation();
  console.log({ location })
  if (location && location.search) {
    const isDuplicate = location.search.indexOf('?dup_') > -1
    const finalId = location.search.replace('?dup_', '').replace('?', '')
    return (<BuilderFromExisting formId={finalId} isDuplicate={isDuplicate} />)
  }
  return <BuilderNew />
}

export default FormBuilder